module.exports = require("jed");